import styled from '@emotion/styled';

import SubmitButton, { SubmitButtonProps } from './SubmitButton';

export type StyledSubmitButtonProps = SubmitButtonProps;

const StyledSubmitButton = styled(SubmitButton)<StyledSubmitButtonProps>({
  padding: 13,
  marginBottom: 11,
  marginTop: 18,
  display: 'block',
  fontWeight: 400,
  maxHeigth: 48,
  height: 48
});

export default StyledSubmitButton;
